import React, { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

const MyProfile = () => {
  const [profile, setProfile] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile({
      ...profile,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Profile submitted: ", profile);
  };
  return (
    <div  className='dashboard-pages-padding'>
      {/* <h1>My Profile</h1> */}
     
        <Row className="justify-content-md-center">
          <Col md={6}>
            <h1>My Profile</h1>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={profile.name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="formMobile">
                <Form.Label>Mobile</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your mobile number"
                  name="mobile"
                  value={profile.mobile}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={profile.email}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="formAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your address"
                  name="address"
                  value={profile.address}
                  onChange={handleChange}
                />
              </Form.Group>

              <button className="save-profile-btn">
                Save Profile
              </button>
            </Form>
          </Col>
        </Row>
    </div>
  );
};

export default MyProfile;
